/**
 * L'accueil de Planification : ses rubriques et leurs
 * pages, lues dans la même table que le menu latéral (`PLANIFICATION`).
 *
 * Aucun compteur ici : les demandes à traiter et le remplissage sont au
 * tableau de bord général, et une information ne s'affiche qu'une fois. Les
 * entrées sans écran restent visibles, avec leur raison.
 */

import { Link } from 'react-router-dom';
import { estActive, PLANIFICATION } from '../../../lib/navigation/espaces';

export default function PlanificationAccueilPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Planification</h1>
        <p className="text-gray-600">
          Les stages et leur programmation, le parascolaire, les demandes des familles, les tarifs,
          les utilisateurs et l’administration du site. Une action prise ici
          qui a une conséquence comptable (une annulation, une note de crédit) arrive d’elle-même en
          comptabilité : elle ne s’y réencode pas.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        {PLANIFICATION.rubriques.map((rubrique) => (
          <section key={rubrique.titre} className="rounded-xl border border-gray-200 bg-white p-5">
            <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-600">{rubrique.titre}</h2>
            <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2">
              {rubrique.entrees.map((e) =>
                estActive(e) ? (
                  <li key={e.chemin}>
                    <Link
                      to={e.chemin}
                      className="flex items-center gap-2 rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-800 hover:bg-gray-50"
                    >
                      <e.icone className="h-4 w-4 text-primary-600" />
                      {e.libelle}
                    </Link>
                  </li>
                ) : (
                  <li key={e.libelle} aria-disabled="true"
                      className="rounded-lg border border-dashed border-gray-200 px-3 py-2 text-sm text-gray-400">
                    {e.libelle}
                    <span className="block text-xs">{e.raison}</span>
                  </li>
                ),
              )}
            </ul>
          </section>
        ))}
      </div>
    </div>
  );
}
